import { appPaths } from 'consts/paths/paths';
import { ParentChildEdit } from 'components/templates';

export const ParentChildEditPage = () => (
    <ParentChildEdit childrenPagePath={appPaths.app.parent['child-profile'].base} />
);
